'use strict';

wbApp.controller('CzMsMtRegistryCtrl', ['$scope', '$modal', '$timeout', '$q', '$translate', '$filter', 'czMsMtRegistrySvc', 'semesterSvc', 'activitySvc',
    function ($scope, $modal, $timeout, $q, $translate, $filter, czMsMtRegistrySvc, semesterSvc, activitySvc) {

        $scope.isSaving = false;
        $scope.filterOptions = {
            filterText: ""
        };

        $scope.semesterID = null;
        $scope.activityID = null;
        $scope.czMsMtRegistry = [];

        $q.all([semesterSvc.getDefaultAsync()])
            .then(function (data) {
                if (data[0]) {
                    $scope.semesterID = data[0].id;
                }

                // $scope.activities = activitySvc.getAllBySemesterIDAsync(
                //     $scope.semesterID != null ? $scope.semesterID : null);
            });

        $scope.onSemesterChange = function (semesterId) {
            $scope.activityID = null;
            $scope.czMsMtRegistry = [];
            setSelectedStudent({});
        }

        $scope.onActivityChange = function (activityId) {
            refreshData();
            setSelectedStudent({});
        }
        
        function refreshData() {
            if (!!$scope.activityID) {
                czMsMtRegistrySvc.findLatestByActivity($scope.activityID).$promise.then(function (data) {
                    $scope.czMsMtRegistry = data;
                });
            }
        }

        function setSelectedStudent(record, refresh) {
            $scope.selectedRecord = record;
            $scope.studentFullName = String.prototype.fullName(record.studentName, record.studentMiddleName, record.studentSurname);
            $scope.parentFullName = String.prototype.fullName(record.userName, record.userMiddleName, record.userSurname);
            
            if (!!record) {
                $scope.$broadcast('selectedStudentChanged', {
                    studentId: record.studentId,
                    refresh: !!refresh,
                    recordId: record.id
                });
            } else {
                $scope.$broadcast('selectedStudentChanged', {
                    studentId: null,
                    refresh: !!refresh,
                    recordId: null
                });                
            }
        }

        $scope.$on('refreshData', function (e, data) {
            refreshData();
        });

        $scope.gridSettings = {
            name: 'czMsMtRegistry',
            columns: [
                {
                    dataField: 'studentSurname',
                    caption: $translate.instant('TXT_LBL_STUDENT'),
                    dataType: 'string',
                   
                    calculateCellValue: function (rowData) {
                        return String.prototype.fullName(rowData.studentName, rowData.studentMiddleName, rowData.studentSurname);
                    }
                },
                {
                    dataField: 'userSurname',
                    caption: $translate.instant('TXT_LBL_PARENT'),
                    dataType: 'string',
                    width: '140px',
                    calculateCellValue: function (rowData) {
                        return String.prototype.fullName(rowData.userName, rowData.userMiddlename, rowData.userSurname);
                    }
                },
                { dataField: 'provoz', caption: 'Provoz', dataType: 'string',  width: '80px',},
                { dataField: 'validFromUtc', caption: $translate.instant('TXT_LAB_VALID_FROM'), dataType: 'date', format: { type: 'shortDate' }, width: '80px' },
                { dataField: 'isValid', caption: 'Validní', dataType: 'boolean', width: '60px' },
                { dataField: 'requireSpecialEducation', caption: 'Spec', dataType: 'boolean', width: '60px' },
            ],
            shouldDisableDelete: function () { return !$scope.selectedRecord || !$scope.selectedRecord.isLast; },
            customCommands: [{
                text: 'Předávání dat (Export XML)',
                callback: function (data) { onShowExportDetailDialog(); },
            }]
        }

        $scope.onRowSelected = function (data) {
            setSelectedStudent(data);
        }

        $scope.onRowAdd = function () {
            if (!!$scope.semesterID && !!$scope.activityID) {
                $q.all([
                    detailDialogPromise.$promise,
                    czMsMtRegistrySvc.createNew($scope.semesterID, $scope.activityID)
                ]).then(function(dataP) {
                    detailDialogPromise.$scope.model = dataP[1];
                    detailDialogPromise.$scope.onRegistryDetailSave = function (data) {
                        refreshData(true);
                        $scope.$broadcast('selectedStudentChanged', { studentId: data.studentId, refresh: true, recordId: data.id });
                    };
                    detailDialogPromise.show();
                })
            }
        }

        
        $scope.onRowEdit = function (data) {

            let modelPromise = czMsMtRegistrySvc.getById(data.id);
            $q.all([modelPromise, detailDialogPromise.$promise]).then(function(model) {
                detailDialogPromise.$scope.model = model[0];
                detailDialogPromise.$scope.onRegistryDetailSave = function (data) {
                    refreshData(true);
                    $scope.$broadcast('selectedStudentChanged', { studentId: data.studentId, refresh: true, recordId: data.id });
                };
                detailDialogPromise.show();
                
            });
        }

        $scope.onRowDelete = function (data) {
            czMsMtRegistrySvc.remove(data.id).$promise.then(function () {
                refreshData(true);
                setSelectedStudent(null);
            });
        }

        $scope.tabs = [
            {
                title: 'TXT_DETAIL',
                template: "cz-ms-mt-registry/detail-tabs/home.html",
            },
            {
                title: 'Všechny věty studenta',
                template: "cz-ms-mt-registry/cz-ms-mt-registry-detail-tabs-student-records.html",
            }
        ];

        $scope.tabs.activeTab = 0;

        $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
            $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
        });
        
        let detailDialogPromise = $modal({
            templateUrl: 'cz-ms-mt-registry/cz-ms-mt-registry-detail.html',
            show: false,
            scope: $scope.$new(true)
        });
        
        function onShowExportDetailDialog() {
            exportDialogPromise.$promise.then(function() {
                exportDialogPromise.show();
            });
        }

        let exportDialogPromise = $modal({
            templateUrl: 'cz-ms-mt-registry/cz-ms-mt-registry-export-detail.html',
            show: false,
            scope: $scope.$new(true)
        });
    }]);